import { render } from "./MoneyCounter.vue?vue&type=template&id=2afbe16c"
import script from "./MoneyCounter.vue?vue&type=script&lang=js"
export * from "./MoneyCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__